/**
 * BundleBuilder-local RHF fork of CommonFields/DesignProductCard.tsx (shared
 * across 8 bundle types — not editable in place). Only the sections/fields
 * BundleBuilder actually renders (per the pre-migration
 * BundleBuilderDesignForm.tsx prop list) are ported.
 */
import { BBProductCardSizes, FontStyles, ImageDisplays } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormInputWithUnit, FormSelect, FormRangeSlider } from "../../../../components/FormFields";
import styles from "../../CommonFields/CommonFields.module.css";

const DesignProductCard = () => {
    return (
        <div>
            <div id="product-card-general">
                <FormSubSection rowLabel="General">
                    <FormColorPicker name="bundles_design.product_background_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.product_border_color" label="Card Border Color" />
                    <FormSelect name="bundles_design.product_img_show" label="Image Display" options={ImageDisplays} />
                    <FormRangeSlider
                        name="bundles_design.product_custom_img_size"
                        min={40}
                        max={400}
                        label="Image Height"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                    <FormRangeSlider
                        name="bundles_design.product_custom_img_size_mobile"
                        min={40}
                        max={400}
                        label="Image Height Mobile"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                    <FormSelect
                        name="product_card_desktop_size"
                        label="Product Card Desktop Size"
                        options={BBProductCardSizes}
                    />
                    <FormSelect
                        name="product_card_mobile_size"
                        label="Product Card Mobile Size"
                        options={BBProductCardSizes}
                    />
                    <FormInputWithUnit
                        name="bundles_design.border_width"
                        min={1}
                        label="Border Width"
                        placeholder="border width"
                        unitSuffix="px"
                    />
                    <FormRangeSlider
                        name="bundles_design.border_radius"
                        min={0}
                        max={100}
                        label="Border Radius"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                </FormSubSection>
            </div>

            <div id="product-card-name">
                <FormSubSection rowLabel="Title">
                    <FormColorPicker name="bundles_design.product_name_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.product_name_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.product_name_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-price">
                <FormSubSection rowLabel="Price">
                    <FormColorPicker name="bundles_design.highlighted_price_tag_color" label="Product Price Color" />
                    <FormInputWithUnit
                        name="bundles_design.highlighted_price_tag_size"
                        min={0}
                        label="Product Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.highlighted_price_tag_style"
                        label="Product Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-compare-at-price">
                <FormSubSection rowLabel="Compare at Price">
                    <FormColorPicker name="bundles_design.product_price_color" label="Compare-at Price" />
                    <FormInputWithUnit
                        name="bundles_design.product_price_size"
                        min={0}
                        label="Compare-at Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.product_price_style"
                        label="Compare-at Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-add-to-cart">
                <FormSubSection rowLabel="CTA">
                    <FormColorPicker name="bundles_design.add_to_cart_bg_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.add_to_cart_text_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.add_to_cart_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.add_to_cart_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="product-card-swatches-selector">
                <FormSubSection rowLabel="Variant Selector">
                    <FormColorPicker name="bundles_design.variant_selector_text_color" label="Color" />
                    <FormInputWithUnit
                        name="bundles_design.variant_selector_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.variant_selector_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="image-popup-design">
                <FormSubSection rowLabel="Image Popup" helpText="Image Popup" hideSeparator>
                    <FormColorPicker name="bundles_design.popup_bg_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.popup_text_color" label="Text Color" />
                </FormSubSection>
            </div>
        </div>
    );
};

export default DesignProductCard;
